import { lazy, Suspense } from 'react';
import { HairBaseColors, HairHighlightColors } from 'shared/types/colorSets';
import { NoColorHairFrontList, SingleColorHairFrontList } from 'shared/types/optionSets';
import { getHighlightColor } from '../utils/HighlightColors';
import { getAvatarViewLayerStyle, HAIR_FRONT_Z_INDEX, STANDARD_LAYER_VIEWBOX } from '../utils/LayoutUtils';

interface Props {
  option: number;
  colorBase: string;
}

/* This component is only used in the main avatar view */
const HairFrontLayer = ({ option, colorBase }: Props) => {
  const viewBox = STANDARD_LAYER_VIEWBOX;
  const style = getAvatarViewLayerStyle(HAIR_FRONT_Z_INDEX);

  const componentName = option < 10 ? `HairFront0${option}` : `HairFront${option}`;
  const HairFrontComponent = lazy(() => import(`shared/components/avatar/hair/${componentName}`));

  const getHairFrontHighlight = () => {
    return getHighlightColor(colorBase, HairBaseColors, HairHighlightColors);
  };

  if (option === 0) {
    return null;
  }

  return (
    <Suspense fallback={<div />}>
      {NoColorHairFrontList.includes(option) && (
        <HairFrontComponent
          viewBoxProp={viewBox}
          style={style}
        />
      )}
      {SingleColorHairFrontList.includes(option) ? (
        <HairFrontComponent
          viewBoxProp={viewBox}
          colorBase={colorBase}
          style={style}
        />
      ) : (
        !NoColorHairFrontList.includes(option) &&
        <HairFrontComponent
          viewBoxProp={viewBox}
          colorBase={colorBase}
          colorHighlight={getHairFrontHighlight()}
          style={style}
        />
      )}
    </Suspense>
  );
}

export default HairFrontLayer;
